<template>
  <div id="sirv-price-widget">
    <PanelPrice />
    <PanelVolume />
    <SliderControl />
  </div>
</template>
<script>
import PanelPrice from '@/components/PanelPrice';
import PanelVolume from '@/components/PanelVolume';
import SliderControl from '@/components/SliderControl';
export default {
  name: 'pricing',
  components: {
    PanelPrice,
    PanelVolume,
    SliderControl
  }
}
</script>
<style lang="scss" scoped>
#sirv-price-widget {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
}
</style>
